import { render, staticRenderFns } from "./app-distribute.vue?vue&type=template&id=f17abe1c&scoped=true"
import script from "./app-distribute.vue?vue&type=script&lang=js"
export * from "./app-distribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17abe1c",
  null
  
)

export default component.exports